import { toast } from "@/app/_providers/toast";
import { env } from "@/env";

const SERVER_URL = env.NEXT_PUBLIC_XI_SERVER_URL;

export const generateVoiceIsolation = async ({ config }: { config: { referenceAudio: File } }) => {
  try {
    const url = `${SERVER_URL}/v1/audio-isolation?allow_unauthenticated=1`;

    const formData = new FormData();
    formData.append("audio", config.referenceAudio);
    const res = await fetch(url, {
      method: "POST",
      body: formData,
    });

    if (res.ok && res.body !== null) {
      return await res.blob();
    } else {
      const { detail } = await res.json();
      throw detail;
    }
  } catch (e: unknown) {
    if (typeof e === "object" && e !== null && "status" in e) {
      const errorStatus = (e as { status: string }).status;
      if (errorStatus in errorMap) {
        toast.error(errorMap[errorStatus].title, { description: errorMap[errorStatus].description });
      } else {
        toast.error("Something went wrong", {
          description: "It looks like there was an issue while generating. Please try again later.",
        });
      }
    } else {
      toast.error("Something went wrong", {
        description: "It looks like there was an issue while generating. Please try again later.",
      });
    }
    throw e;
  }
};

const errorMap: { [key: string]: { description: string; title: string } } = {
  quota_exceeded: {
    title: "Quota Exceeded",
    description:
      "You have reached the limit of available requests on the landing page. You can continue, for free, by signing-up to the platform.",
  },
  system_busy: {
    title: "Sytem Busy",
    description: "The system is currently experiencing unusually high levels of activity. Please try again later.",
  },
  max_character_limit_exceeded: {
    title: "Character Limit Exceeded",
    description: "The sample you uploaded or recorded is too long. Please try again with a shorter sample.",
  },
  invalid_audio_duration: {
    title: "Audio Too Short",
    description:
      "We currently only accept audio with a minimum duration of 4.6 seconds. Please try again with a longer sample.",
  },
};
